import { Component, OnInit, ChangeDetectorRef, NgZone } from '@angular/core';
import { AppUris } from '../../entities/app-config/model';
import { TranslateService } from '../../translate/index';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute, Router } from '@angular/router';
import { ManageEquipmentService } from './manage-equipment.service';
import { EquipmentDetails, SystemDetails, ComponentDetails, Inspection, ComponentWearGraph, InspectionListVM, ComponentCMU, EquipmentEnum, EquipmentModal, EquipmentStatusViewModel, EquipmentCompartmentTypeModel } from './models/manage-equipment.model';
import { LoadingService } from '../../shared/services/loading.service';
import { UserService } from '../../shared/services/user.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AppService } from '../../app.service';
import { trigger, style, animate, transition } from '@angular/animations';
import { MatDialog } from '@angular/material/dialog'; import { ChangeJobsiteComponent } from './components/change-jobsite/change-jobsite.component';
import { UpdateMeterComponent } from './components/update-meter/update-meter.component';
import { ChangeMeterUnitComponent } from './components/change-meter-unit/change-meter-unit.component';
import { UpdateInspectionForecastingComponent } from './components/update-inspection-forecasting/update-inspection-forecasting.component';
import { InspectionPlannerComponent } from './components/inspection-planner/inspection-planner.component';
import { CreateNewTemperatureInspectionComponent } from '../Temperature/create-new-temperature-inspection/create-new-temperature-inspection.component';
import { TemperatureInspectionService } from '../Temperature/temperature-inspection.service';
import { TemperatureInspectionListVM } from '../Temperature/temperature-inspection.module';
import { SetupEquipmentService } from '../setup-equipment/setup-equipment.service';
import { Equipment, EquipmentInspectionForcastingViewModel } from '../setup-equipment/setup-equipment.model';
import { ViewPhotoComponent } from '../interpretation/components/view-photo/view-photo.component';
import { CreateDialogThermographyComponent } from '../Thermography/create-dialog-thermography/create-dialog-thermography.component';
import { NotificationsService } from 'angular2-notifications';
import { PreferencesService } from '../preferences/preferences.service';
import { CreateRopeshovelInspectionComponent } from './components/create-ropeshovel-inspection/create-ropeshovel-inspection.component';
import { DeleteConfirmDigilatFormDialogComponent } from '../GET_NEW_UI/digital-form-fill/component/delete-confirm-dialog/delete-confirm-dialog.component';
import { InspectionAttachedDocsComponent } from '../GET_NEW_UI/inspection-attached-docs/inspection-attached-docs.component';
import { CustomerServiceIdentity } from '../IDENTITY_WEB/services/customer.service';
import { CommentPopupRequestPageAndFunc, ConditionCommentModalComponent } from '../interpretation/components/condition-comment-modal/condition-comment-modal.component';
import { InterpretationService } from '../interpretation/interpretation.service';
import { EditSystemSerialNumberComponent } from '../interpretation/components/edit-system-serial-number/edit-system-serial-number.component';
import { EquipmentFamily, ManageEquipmentColumn, ScreenCode, toolType } from '../../shared/enums/allEnums';
import moment from 'moment';
import { CustomeEvaluationRangeVM } from '../CustomEval/custom-eval.model';
import { CustomEvalService } from '../CustomEval/custom-eval.service';
import { AddNewComponentComponent } from './components/add-new-component/add-new-component';
import { GridColumn } from '../preferences/models/preferences.model';
import { AvgWornCalculationPopUpComponent } from './avg-worn-calculation-pop-up/avg-worn-calculation-pop-up.component';
import { QuoteService } from '../interpretation/quote-service.service';
import { DatePipe } from '@angular/common';
import { EquipmentNotesHistoryComponent } from '../../shared/components/equipment-notes-history/equipment-notes-history.component';
import { UserGridPreferenceUpdateDto } from "../../modules/preferences/models/preferences.model";
import { AddEqualiserBarComponentComponent } from './components/add-new-component/add-equaliser-bar-component/add-equaliser-bar-component';
import { EqualiserBar } from '../../entities/setup/model' 
import { MatTabChangeEvent } from '@angular/material/tabs';

@Component({
  selector: 'manage-equipment',
  templateUrl: './manage-equipment.component.html',
  styleUrls: ['./manage-equipment.component.scss'],
  animations: [
    trigger(
      'enterAnimation', [
      transition(':enter', [
        style({ transform: 'translateY(25%)', opacity: 0 }),
        animate('500ms', style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        style({ transform: 'translateY(0)', opacity: 1 }),
        animate('500ms', style({ transform: 'translateY(100%)', opacity: 0 }))
      ])
    ]
    )]
})
// @NgModule({
//     imports: [WidgetsModule]
// })
export class ManageEquipmentComponent implements OnInit {

  //charts

  title: string;

  width = "100%";
  height = "600";
  type = "msline";
  dataFormat = "json";
  dataSourceLEFT: any;
  dataSourceRIGHT: any;
  //end charts varibles
  equipmentId: number;
  equipmentDetails: EquipmentDetails;
  EquipmentCompartmentTypeModel: EquipmentCompartmentTypeModel[] = [];
  appUris: AppUris; // = new AppUris;
  isInspector = false;
  showNotreleasdInspections = false;
  isUCOnly = false;
  isInterpreter = false;
  systemsLoaded = false;
  inspectionsLoaded = false;
  inspections: Inspection[] = [];
  public shouldDisableSetup = false;
  translateSubscription: Subscription;
  userLanguage = 'english';
  pdfUoM = 'mm';
  EvalautionRange: CustomeEvaluationRangeVM;
 dashboardPreferneceView: number[] = []
  DashboardPrefernceList: GridColumn[]
  nextInspectionDate: string;
  PercentOfDifference: number;
  FamilyImage_Chain: string;
  FamilyImage_Frame: string;

  ropeStyleId: number;
  //Temperature Variables

  TemperatureEnabled: string;
  TempEnabled: boolean = false;

  hasTemperatureInspection: boolean = false;
  eqName: string;
  TemperatureInspectionList: TemperatureInspectionListVM[] = [];


  ThermographyEnabled: string;
  ThermEnabled: boolean = false;
  MaintenaceEnables: boolean = false;
  IsAllowToggleCRoller: boolean = false;

  UCSetupType: number;
  EquipmentModal: EquipmentModal;
  showFrameConfiguration: boolean = false;
  showCannonType: boolean = false;
  reportUri = '';
  public editableSerialNo: boolean = true;
  public dynamicInput: string = "dataInput_";
  public currentClickedId: string;
  public editableBudgetLife: boolean = true;
  public editUnitNo: boolean = true;
  public editAdditionalUnitNo: boolean = true;
  public editableSystemBudgetLife: boolean = true;
  public editableSysBudgetDistance: boolean = true;

  public TogglePencil: boolean = false;
  private userId = 1;
  showCMU: boolean = true;
  showResLife100: boolean = true;
  showResLife120: boolean = true;
  showReading: boolean = true;
  showWorn0: boolean = true;
  showWorn100: boolean = true;
  showDOC: boolean = true;
  showResDOC100: boolean = true;
  showResDOC120: boolean = true;
  showInstallDate: boolean = false;
  showPropelBudget: boolean = false;
  EnableDistTravelledTracking: boolean;
  ShowPropelHrsPerc: boolean;
  showWorkOrder: boolean = true;
  showBudgetWearRate: boolean = true;
  showActualWearRate: boolean = true;
  showBrand: boolean = true;
  showBudgetLife: boolean = true;
  showBushTurned: boolean = true;
  showProjectedLife100: boolean = true;
  showProjectedLife120: boolean = true;
  showDifference: boolean = true;
  showResidualDOC: boolean = true;
  showPurchaseCost: boolean = true;
  showRepairCost: boolean = true;
  public editableWO: boolean = true;
  loading: boolean = false;
  renameSprocket: boolean = false;
  editComponent: boolean = false;
  isFamilyRS: boolean;
  isAdminAllowEdit: boolean = false;
  userUOD: string = 'km';
  toolType = toolType;
  allEquipmentStatus: EquipmentStatusViewModel;
  equipmentConditionStatuses: EquipmentStatusViewModel[]=[];
  enableBogieShim: boolean = false;
  enableManualInspection: boolean = false;
  addCompRight: boolean = false; // permission to add new component on manage equipment page

  selectedSeries: string = "";
  selectedData: string = "Click a data point to see details";
  enableLeft: boolean = false;
  enableRight: boolean = false;
  equipment_: Equipment = new Equipment();
  isloaded: boolean = false;
  userUOM: string;
  isBasicUser: number = 1;
  hasCRoller: boolean = false;
  ShowCRoller: boolean = true;
  showReplacementDate: boolean = false;
  toDaysDate: Date;
  showEnableReplaceExistingTab: boolean = false;

  systemIds: number[] = [];
  enableEqualiserBar: boolean = false;
  equaliserBarData: EqualiserBar;
  isEqualiserBarExists: boolean = false;
  isFromShovelDashBoard: boolean=false;
  downloadingPdf: boolean = false;

  tabularTabClicked: boolean = false;
  isOptionsVisible: boolean = true;

  constructor(private datePipe: DatePipe, private zone: NgZone, private _translate: TranslateService, private _route: ActivatedRoute,
    private _ref: ChangeDetectorRef, private _equipmentService: ManageEquipmentService, private _loading: LoadingService, private _sanitizer: DomSanitizer,
    private _app: AppService, private _userService: UserService,
    private _dialog: MatDialog, private _router: Router,
    private _temperatureService: TemperatureInspectionService,
    private _setupService: SetupEquipmentService, private _notification: NotificationsService,
    private _appService: AppService,
    private notification: NotificationsService,
    private readonly _pref: PreferencesService, private _customerService: CustomerServiceIdentity,
    private _interp: InterpretationService, private _evalService: CustomEvalService,
    private _quotes: QuoteService
  ) {
    this._interp.getUserId().subscribe(r => this.userId = r, err => console.error(err));
  }

  ngOnInit() {
    this.isOptionsVisible = true;
    this.toDaysDate = new Date();
    this._app.setPageTitle('Manage Equipment');
    this.getReportUrl();
    this._app.getAppUris().subscribe(result => { this.appUris = result; });
    this.translateSubscription = this._translate._getPrefLang().subscribe(lang => setTimeout(() => { this.updateUserLang(lang); }, 2));
    this.equipmentId = this._route.snapshot.params.id;
    this.loadSystemIds();
    //this.getFamilyRenameSprocketFlag();
    this.getEquipmentStatus();
    this.GetEquipmentConditionStatuses();
    this.getReplaceExistingTabStatus();
    //this.GetGridColumnsWithUserPreference();
    this._customerService.CheckUCUserType().subscribe(result => {
      this.isBasicUser = result;

    });
    this.CheckFindIspectionMenuAccess();
    this.GetEQDetails();
    this.loadUserJobRoles();
    this.CheckHasAccessToNewInspection();
    this.LoadEvalautionForEquipment();
    this.loadEquipmentInspections();
    this.loadEquipmentDetails();
    this.isAllowEditByUserId();
    this._pref.getShowMaintenanceInsp().subscribe(res => {
      if (res == "True") {
        this.MaintenaceEnables = true;
      } else {
        this.MaintenaceEnables = false;
      }
    });
    this.dataSourceLEFT = {
      categories: [{ category: [] }],
      dataset: [
        { data: [] }
      ]
    };

    this.getPDFUoM();
    this.getRopeShovelReportSyle();
    this.LoadComponentInstallCMU();
    this.LoadChartLEFT();
    this.LoadChartRIGHT();
    this.getUserUOM();
    this._app.getApplicationConfigValue("TemperatureEnabled").subscribe(result => {
      this.TemperatureEnabled = result
      console.log("this.TemperatureEnabled", this.TemperatureEnabled)
      if (this.TemperatureEnabled == "1") {
        this.TempEnabled = true;
        this.LoadTemperatureInspectionsForEquipment();

      } else {
        this.TempEnabled = false;
      }

    });

    this._app.GetDeafultUCSetupType().subscribe((res: any) => {
      this.UCSetupType = res;
    })
    this.getUserUOD();
    this.getFamilyRenameSprocketFlag();
  }

  getReplaceExistingTabStatus() {
    this._pref.GetReplaceExistingTabStatus().subscribe(res => {
      if (res == "True") {
        this.showEnableReplaceExistingTab = true;
      } else {
        this.showEnableReplaceExistingTab = false;
      }
    });
  }

  getUserUOM() {
    this._pref.getGeneralTabPreferences().subscribe(res => {
      this.userUOM = res.UnitOfMeasurementName;
    })
  }
  ngAfterContentChecked() {
    this._ref.detectChanges();
  }
  isDueForInspection(): boolean {
    const today = moment(this.toDaysDate).format('MM/DD/YYYY');
    const nextInspDate = moment(this.equipmentDetails.NextInspectionDate).format('MM/DD/YYYY');
    if (today >= nextInspDate) {
      return true;
    } else {
      return false
    }

  }

  loadSystemIds() {
    this._equipmentService.getSystemIds(this.equipmentId).subscribe(systems => {
      this.systemIds = systems;
      console.log('this.systemIds', this.systemIds);
    });
  }

  onSaveEquipmentDetail(type: number) {

    var model = {}
    if (type == 1) {
      model = { equipmentId: this.equipmentId, equipmentDetail: EquipmentEnum.SerialNumber, EquipmentData: this.equipmentDetails.SerialNumber };
    }
    else if (type == 2) {
      model = { equipmentId: this.equipmentId, equipmentDetail: EquipmentEnum.UnitNumber, EquipmentData: this.equipmentDetails.UnitNumber };
    }
    else {
      model = { equipmentId: this.equipmentId, equipmentDetail: EquipmentEnum.AdditionUnit, EquipmentData: this.equipmentDetails.AdditionalUnitNo };
    }
    this._equipmentService.UpdateEquipmentDetail(model).subscribe(item => {
      if (item) {
        this.editableSerialNo = true;
        this.editUnitNo = true;
        this.editAdditionalUnitNo = true;
        this.notification.success("Record saved succesfully.")
      }
    }
    )
  }
  onCancelEquipmentDetail(type: number) {
    if (type == 1) {
      this.editableSerialNo = true;
    }
    else if (type == 2) {
      this.editUnitNo = true;
    }
    else {
      this.editAdditionalUnitNo = true;
    }

  }
  editEquipmentDetail(type: number) {
    this.editableSerialNo = true;
    this.editUnitNo = true;
    this.editAdditionalUnitNo = true;
    if (type == 1) {
      this.editableSerialNo = false;
    }
    else if (type == 2) {
      this.editUnitNo = false;
    }
    else {
      this.editAdditionalUnitNo = false;
    }
  }
  getDynamicValue(index: number): string {
    console.log(this.dynamicInput + index);
    return this.dynamicInput + index;
  }
  onSaveBudgetLife(type: number, BudgetLife: number, componentName: string) {
    this.editableBudgetLife = true;
    var model = { ComponenetId: type, BudgetLife: BudgetLife, equipmentid_auto: this.equipmentId, ComponentName: componentName };

    this._equipmentService.UpdateBudgetDetail(model).subscribe(item => {
      if (item) {
        this.notification.success("Record saved succesfully.")
        this.TogglePencil = !this.TogglePencil;
      }
    });
  }
  onSaveWO(ActionWOId: number, ActionWO: string) {
    this.editableWO = true;
    var model = { ActionWOId: ActionWOId, ActionWO: ActionWO };
    this._equipmentService.UpdateActionWO(model).subscribe(item => {
      if (item) {
        this.notification.success("Record saved succesfully.")
      }
    });
  }
  togglePencilClick() {
    this.TogglePencil = !this.TogglePencil;
  }
  onCancelBudgetLife() {
    this.editableBudgetLife = true;
  }
  editBudgetLife(type: number) {
    this.currentClickedId = type.toString();
    this.editableBudgetLife = false;
  }
  editWO(type: number) {
    this.currentClickedId = type.toString();
    this.editableWO = false;
  }
  onCancelWO() {
    this.editableWO = true;
  }
  editSysBudgetLife(type: number) {
    this.currentClickedId = type.toString();
    this.editableSystemBudgetLife = false;
  }
  onSaveSysBudgetLife(Id: number, BudgetLife: number) {
    this.editableSystemBudgetLife = true;
    this.UpdateBudgetLife(Id, BudgetLife);
  }
  editableFrameCost: boolean;
  onSaveSystemFrameCost(Id: number, FrameCost: number) {
    this.editableFrameCost = true;
    this.UpdateFrame(Id, FrameCost);
  }

  editSysFrameCost(type: number) {
    this.currentClickedId = type.toString();
    this.editableFrameCost = false;
  }
  onCancelFrameCost() {
    this.editableFrameCost = true;
  }
  onCancelSysBudgetLife() {
    this.editableSystemBudgetLife = true;
  }
  editSysBudgetDistance(type: number) {
    this.currentClickedId = type.toString();
    this.editableSysBudgetDistance = false;
  }
  onSaveSysBudgetDistance(Id: number, BudgetDistance: number) {
    this.editableSysBudgetDistance = true;
    this.UpdateBudgetDistance(Id, BudgetDistance);
  }
  onCancelSysBudgetDistance() {
    this.editableSysBudgetDistance = true;
  }
  checkDateEdit(equipmentDetails: any): boolean {
    var localDate = new Date('06.18.2023');
    if (new Date(equipmentDetails.EquipmentCreatedDate) > localDate) {
      return true;
    } else {
      return true;
    }

  }
  reloadEquipmentOverview: boolean = true;
  HideShowCRoller() {
    console.log('carrier roller', this.ShowCRoller, this.hasCRoller,);
    if (this.IsAllowToggleCRoller) {
      //this.equipmentSystems = this.equipmentSystemsCopy;
      this.ShowCRoller = !this.ShowCRoller;
      this.UpdateShowhideCRoller(this.ShowCRoller);
      console.log('carrier roller', this.ShowCRoller, this.hasCRoller);
      //if (this.ShowCRoller == false) {
      //  this.equipmentSystems = this.equipmentSystems.map(system => {
      //    const filteredComponents = system.Components.filter(component => component.CompartTypeId !== 234);
      //    return { ...system, Components: filteredComponents };
      //  });


      //} else {
      //  this.equipmentSystems = this.equipmentSystemsCopy;
      //}
    }



  }
  LoadComponentInstallCMU() {
    this._equipmentService.getComponentsInstallCMU(this.equipmentId).subscribe(result => {
      this.componetInstallCMU = result;
      console.log("componetInstallCMU ", this.componetInstallCMU)
    })
  }

  InspectionDatesList: InspectionListVM[] = [];
  CompInspectionInfo: ComponentWearGraph[] = [];
  CompInspectionInfoFilter: ComponentWearGraph[] = [];

  InspectionDatesList_R: InspectionListVM[] = [];
  CompInspectionInfo_R: ComponentWearGraph[] = [];
  CompInspectionInfoFilter_R: ComponentWearGraph[] = [];
  loadingChart: boolean = true;

  getUnique(arr, comp) {

    const unique = arr
      .map(e => e[comp])

      // store the keys of the unique objects
      .map((e, i, final) => final.indexOf(e) === i && i)

      // eliminate the dead keys & store unique objects
      .filter(e => arr[e]).map(e => arr[e]);

    return unique;
  }

  //load chart LEFT
  componetInstallCMU: ComponentCMU[] = [];
  CompInspections: any[] = [];
  LoadChartLEFT() {
    this.loadingChart = true;
    this._equipmentService.getComponentsInstallCMU(this.equipmentId).subscribe(result => {
      this.componetInstallCMU = result;
    })
    this._equipmentService.getEquipmentInspectionsForComponentsLEFT(this.equipmentId).subscribe(res => {
      // console.log("Chart Info ", res)
      this.CompInspectionInfo = res;
      this.CompInspectionInfoFilter = res;
      this.CompInspectionInfoFilter = this.getUnique(this.CompInspectionInfoFilter, 'SMU')
      this.CompInspections = this.CompInspectionInfoFilter;
      if (this.CompInspectionInfoFilter.length > 0) {
        this.CompInspectionInfoFilter.map(x => {
          let obj1 = new InspectionListVM();
          obj1.Name = x.CompartName;
          obj1.SMU = x.SMU;
          obj1.InspectionTypeId = x.InspectionTypeId;
          obj1.IsProjected = x.IsProjected;
          obj1.SMUProjected = x.SMUProjected;
          this.InspectionDatesList.push(obj1);
        })

        if (this.InspectionDatesList.length > 0) {
          if (
            this.dataSourceLEFT &&
            this.dataSourceLEFT.categories &&
            this.dataSourceLEFT.categories.length > 0
          ) {
            this.dataSourceLEFT.categories[0].category = [];
          }

          // this.componetInstallCMU.map(y => {
          //   if (y.CompName == "Budget") {
          //     let obj1 = new InspectionListVM();
          //     obj1.Name = y.CompName;
          //     obj1.SMU = y.CMU;


          //     this.InspectionDatesList.push(obj1);

          //     let obj2 = new ComponentWearGraph();
          //     obj2.CompartName = y.CompName;
          //     obj2.Date = new Date();
          //     obj2.SMU = y.CMU;
          //     obj2.WornPercentage = 100;
          //     obj2.InspectionTypeId=y.InspectionTypeId;
          //     obj2.IsProjected=y.IsProjected;
          //     obj2.SMUProjected=y.SMUProjected;
          //     this.CompInspectionInfo.push(obj2);
          //   }
          // });


          this.InspectionDatesList.sort(this.compareSMU);
          this.InspectionDatesList.forEach((i) => {
            if (i != null) {
              if (i.Name == "EQ") {
                this.dataSourceLEFT.categories[0].category.push({ "label": 'Install' + '<br/>' + i.SMU });
              } else {
                this.dataSourceLEFT.categories[0].category.push({ "label": (i.InspectionTypeId == 1) || i.IsProjected == true ? null : i.SMU + '<br/>' + 'Hrs' });
              }
            }
          });
          this.PushDataToGraph_LEFT();
        }
      }
    })
  }

  compareSMU(a, b) {
    // Use toUpperCase() to ignore character casing
    const bandA = a.SMU;
    const bandB = b.SMU;

    let comparison = 0;
    if (bandA > bandB) {
      comparison = 1;
    } else if (bandA < bandB) {
      comparison = -1;
    }
    return comparison;
  }


  LoadChartRIGHT() {
    this.loadingChart = true;
    this._equipmentService.getComponentsInstallCMU(this.equipmentId).subscribe(result => {
      this.componetInstallCMU = result;
    })
    this._equipmentService.getEquipmentInspectionsForComponentsRIGHT(this.equipmentId).subscribe(res => {
      this.CompInspectionInfo_R = res;
      this.CompInspectionInfoFilter_R = res;
      this.CompInspectionInfoFilter_R = this.getUnique(this.CompInspectionInfoFilter_R, 'SMU')
      if (this.CompInspectionInfoFilter_R.length > 0) {
        this.CompInspectionInfoFilter_R.map(x => {
          let obj1 = new InspectionListVM();
          obj1.Name = x.CompartName;
          obj1.SMU = x.SMU;
          obj1.InspectionTypeId = x.InspectionTypeId;
          obj1.IsProjected = x.IsProjected;
          obj1.SMUProjected = x.SMUProjected;
          this.InspectionDatesList_R.push(obj1);
        })

        if (this.InspectionDatesList_R.length > 0) {
          this.dataSourceRIGHT.categories ??= [];
          this.dataSourceRIGHT.categories[0] ??= { category: [] };
          this.dataSourceRIGHT.categories[0].category = [];
          // this.componetInstallCMU.map(y => {
          //   if (y.CompName == "Budget") {
          //     //this.dataSourceRIGHT.categories[0].category.push({ "label":  y.CMU + '<br/>' + 'Hrs'  });
          //     let obj1 = new InspectionListVM();
          //     obj1.Name = y.CompName;
          //     obj1.SMU = y.CMU;
          //     this.InspectionDatesList_R.push(obj1);
          //     let obj2 = new ComponentWearGraph();
          //     obj2.CompartName = y.CompName;
          //     obj2.Date = new Date();
          //     obj2.SMU = y.CMU;
          //     obj2.WornPercentage = 100;
          //     obj2.InspectionTypeId = y.InspectionTypeId;
          //     obj2.IsProjected = y.IsProjected;
          //     obj2.SMUProjected = y.SMUProjected;
          //     this.CompInspectionInfo_R.push(obj2);
          //   }
          // })
          this.InspectionDatesList_R.sort(this.compareSMU);
          this.InspectionDatesList_R.forEach((i) => {
            if (i != null) {
              if (i.Name == "EQ") {
                this.dataSourceRIGHT.categories[0].category.push({ "label": 'Install' + '<br/>' + i.SMU });
              } else {
                this.dataSourceRIGHT.categories[0].category.push({ "label": (i.InspectionTypeId == 1) || i.IsProjected == true ? null : i.SMU + '<br/>' + 'Hrs' });
              }
            }
          });
          this.PushDataToGraph_RIGHT();
        }
      }
    })
  }

  PushDataToGraph_LEFT() {
    if (!this.dataSourceLEFT) {
      this.dataSourceLEFT = {};
    }
    if (!this.dataSourceLEFT.dataset) {
      this.dataSourceLEFT.dataset = [];
    }
    for (let i = 0; i <= 7; i++) {
      if (!this.dataSourceLEFT.dataset[i]) {
        this.dataSourceLEFT.dataset[i] = { data: [] };
      } else {
        this.dataSourceLEFT.dataset[i].data = [];
      }
    }
    this.InspectionDatesList.map((i, index) => {
      this.CompInspectionInfo.map(x => {
        if (x.SMU == i.SMU) {
          this.PushData_LEFT(x, index);

        }
      })
    })
    this.buildProjectedByNearestSMULeft(0, 4, null);
    this.buildProjectedByNearestSMULeft(1, 5, null);
    this.buildProjectedByNearestSMULeft(2, 6, null);
    this.buildProjectedByNearestSMULeft(3, 7, null);
    this.dataSourceLEFT.dataset.map(i => {
      if (!i.seriesname?.includes("Projection")) {
        let count = 0;
        let arr = [];

        i.data.map((d, i) => {
          if (d.value == null) {
            d.value = ""
          }
          if (i != 0 && !d.smu) {
            count = 1;
          }
          if (count == 1) {
            if (!d.isProjected) {
              arr.push(null);
            }
          } else {
            if (!d.isProjected) {
              arr.push(d);
            }
          }
        })
        i.data = arr;
      } else {
        let count = 0;
        let arr = [];
        let count_ = 0;
        let lastvalarr = 0
        i.data.map((d, index) => {
          if (d.value == null) {
            d.value = ""
          }
          if (index != 0) {
            count = 1;
            count_ = count_ + 1;
          }
          if (count != 1) {
            arr.push(null);
          } else {
            if (lastvalarr == 0) {
              arr[index - 1] = i.data[index - 1]
              d.smu = d.smuProjected
              arr.push(d);
              lastvalarr++;
            } else {

              d.smu = d.smuProjected
              arr.push(d);
            }
          }
        })
        i.data = arr;
      }
    })
    this.loadingChart = false;
  }
  //LEFT
  PushData_LEFT(c, index) {
    switch (c.CompartName) {
      case "Link":
        this.dataSourceLEFT.dataset[0].data[index] = { "tooltext": !c.IsProjected && c.WornPercentage != null && c.WornPercentage != 100 ? `<b>${c.WornPercentage}%</b> at ${c.SMU} SMU` : "", "smuProjected": c.SMUProjected, "isProjected": c.IsProjected, "value": c.WornPercentage, "index": index, "smu": c.SMU, "budget": false };
        break;
      case "Bush":
        this.dataSourceLEFT.dataset[1].data[index] = { "tooltext": !c.IsProjected && c.WornPercentage != null && c.WornPercentage != 100 ? `<b>${c.WornPercentage}%</b> at ${c.SMU} SMU` : "", "smuProjected": c.SMUProjected, "isProjected": c.IsProjected, "value": c.WornPercentage, "index": index, "smu": c.SMU, "budget": false };
        break;
      case "Shoe":
        this.dataSourceLEFT.dataset[2].data[index] = { "tooltext": !c.IsProjected && c.WornPercentage != null && c.WornPercentage != 100 ? `<b>${c.WornPercentage}%</b> at ${c.SMU} SMU` : "", "smuProjected": c.SMUProjected, "isProjected": c.IsProjected, "value": c.WornPercentage, "index": index, "smu": c.SMU, "budget": false };

        break;
      case "Spocket":
        this.dataSourceLEFT.dataset[3].data[index] = { "tooltext": !c.IsProjected && c.WornPercentage != null && c.WornPercentage != 100 ? `<b>${c.WornPercentage}%</b> at ${c.SMU} SMU` : "", "smuProjected": c.SMUProjected, "isProjected": c.IsProjected, "value": c.WornPercentage, "index": index, "smu": c.SMU, "budget": false };
        break;
      default:
        break;
    }

  }
  buildProjectedByNearestSMULeft(smuDatasetIndex: number, targetIndex: number, emptyValue: any = null) {
    const datasets = this.dataSourceLEFT?.dataset;
    if (!datasets) return;

    const smuData = datasets[smuDatasetIndex]?.data || [];

    // Ensure target dataset exists
    if (!datasets[targetIndex]) {
      datasets[targetIndex] = { data: [] };
    }

    // Initialize target with empty values
    const targetData = smuData.map(() => ({ value: emptyValue }));

    // STEP 1: Find last actual (isProjected === false)
    let lastActualIndex = -1;
    smuData.forEach((item: any, index: number) => {
      if (item?.isProjected === false && item?.value != null) {
        lastActualIndex = index;
      }
    });

    // ✅ ONLY scan selected dataset
    const selectedDataset = datasets[smuDatasetIndex];

    selectedDataset?.data?.forEach((item: any) => {
      if (item?.smuProjected && item.smuProjected > 0) {

        item.tooltext =
          item.isProjected && item.value != null
            ? `<b>${item.value == 100 ? 100 : 120}%</b> at ${item.smu} SMU`
            : '';

        let nearestIndex = -1;
        let minDiff = Number.MAX_VALUE;

        // Find nearest SMU
        smuData.forEach((smuItem: any, index: number) => {
          if (smuItem?.smu != null) {
            const diff = Math.abs(smuItem.smu - item.smuProjected);
            if (diff < minDiff) {
              minDiff = diff;
              nearestIndex = index;
            }
          }
        });

        // STEP 3: Add connector point
        if (lastActualIndex !== -1) {
          targetData[lastActualIndex] = {
            ...smuData[lastActualIndex],
            index: lastActualIndex
          };
        }

        // STEP 4: Place projected at nearest index
        if (nearestIndex !== -1) {
          targetData[nearestIndex] = {
            ...item,
            smu: item.smuProjected,
            index: nearestIndex
          };
        }
      }
    });

    // Cleanup tooltext
    targetData.forEach((item: any) => {
      if (item?.tooltext && item.value !== 100 && item.value !== 120) {
        item.tooltext = '';
      }
    });

    const lastIndex = targetData.length - 1;

    // const targetDataFiltered = targetData.map((item: any, index: number) => {
    //   if (item?.tooltext === '' || index === lastIndex) {
    //     return item;
    //   }
    //   return { value: null };
    // });

    datasets[targetIndex].data = targetData;
  }


  PushDataToGraph_RIGHT() {
    this.dataSourceRIGHT = this.dataSourceRIGHT || {};
    this.dataSourceRIGHT.dataset = this.dataSourceRIGHT.dataset || [];
    for (let i = 0; i < 8; i++) {
      this.dataSourceRIGHT.dataset[i] = this.dataSourceRIGHT.dataset[i] || {};
      this.dataSourceRIGHT.dataset[i].data = [];
    }
    this.InspectionDatesList_R.map((i, index) => {
      this.CompInspectionInfo_R.map(x => {
        if (x.SMU == i.SMU) {
          this.PushData_RIGHT(x, index);
        }
      })
    })

    this.buildProjectedByNearestSMURight(0, 4, null);
    this.buildProjectedByNearestSMURight(1, 5, null);
    this.buildProjectedByNearestSMURight(2, 6, null);
    this.buildProjectedByNearestSMURight(3, 7, null);
    this.dataSourceRIGHT.dataset.map(i => {
      if (!i.seriesname?.includes("Projection")) {
        let count = 0;
        let arr = [];

        i.data.map((d, i) => {
          if (d.value == null) {
            d.value = ""
          }
          if (i != 0 && !d.smu) {
            count = 1;

          }
          if (count == 1) {
            arr.push(null);
          } else {
            if (!d.isProjected) {

              arr.push(d);
            }
          }
        })
        i.data = arr;
      } else {
        let count = 0;
        let arr = [];
        let count_ = 0;
        let lastvalarr = 0
        i.data.map((d, index) => {
          if (d.value == null) {
            d.value = ""
          }
          if (index != 0) {
            count = 1;
            count_ = count_ + 1;
          }
          if (count != 1) {
            arr.push(null);
          } else {
            if (lastvalarr == 0) {
              arr[index - 1] = i.data[index - 1]
              d.smu = d.smuProjected
              arr.push(d);
              lastvalarr++;
            } else {
              d.smu = d.smuProjected
              arr.push(d);
            }
          }
        })
        i.data = arr;
      }
    }
    )
    //console.log("This.dataSource_RIGHT", this.dataSourceRIGHT)
    // this.dataSourceRIGHT.dataset.map(b => {
    //   let cmu;
    //   let budgethrs;
    //   let firstIndexValue = this.CompInspectionInfoFilter_R[0].SMU;
    //   let LinkCMU = this.componetInstallCMU.find(x => x.CompName == "Link");
    //   let installLinkCMU = 0;
    //   if (LinkCMU) {
    //     installLinkCMU = LinkCMU.CMU;
    //   }
    //   let lastIndex;
    //   let budget;
    //   //console.log("BUDGET_____",  b.data)
    //   if (b.seriesname == "Budget") {
    //     lastIndex = b.data.length;
    //     b.data.map((x, index) => {

    //       if (index != 0) {
    //         // console.log("BUDGET_____!!!!!", x)
    //         let LinkBudget = this.componetInstallCMU.find(x => x.CompName == "Budget");
    //         budget = LinkBudget.CMU;
    //         cmu = (x.smu - firstIndexValue) + installLinkCMU;

    //         let value = Math.pow(cmu, 2) / (Math.pow(budget, 2) / 100)
    //         x.value = value > 120 ? 120 : value;

    //       }

    //     })

    //     let budget120 = Math.round(budget * 1.1);


    //     let previousvalue = this.dataSourceRIGHT.dataset[8].data[lastIndex - 1].smu;
    //     // console.log("previousssss__RIGHTTTTT", previousvalue)
    //     if (previousvalue < budget120) {
    //       this.dataSourceRIGHT.categories[0].category.push({ "label": budget120 + '<br/>' + 'Hrs' });
    //       this.dataSourceRIGHT.dataset[8].data[lastIndex] = { "value": 120, "index": lastIndex, "budget": true };

    //     }

    //   }

    // })
    this.loadingChart = false;
  }

  //RIGHT
  PushData_RIGHT(c, index) {
    switch (c.CompartName) {
      case "Link":
        this.dataSourceRIGHT.dataset[0].data[index] = { "tooltext": !c.IsProjected && c.WornPercentage != null ? `<b>${c.WornPercentage}%</b> at ${c.SMU} SMU` : "", "smuProjected": c.SMUProjected, "isProjected": c.IsProjected, "value": c.WornPercentage, "index": index, "smu": c.SMU };
        break;
      case "Bush":
        this.dataSourceRIGHT.dataset[1].data[index] = { "tooltext": !c.IsProjected && c.WornPercentage != null ? `<b>${c.WornPercentage}%</b> at ${c.SMU} SMU` : "", "smuProjected": c.SMUProjected, "isProjected": c.IsProjected, "value": c.WornPercentage, "index": index, "smu": c.SMU };
        break;
      case "Shoe":
        this.dataSourceRIGHT.dataset[2].data[index] = { "tooltext": !c.IsProjected && c.WornPercentage != null ? `<b>${c.WornPercentage}%</b> at ${c.SMU} SMU` : "", "smuProjected": c.SMUProjected, "isProjected": c.IsProjected, "value": c.WornPercentage, "index": index, "smu": c.SMU };

        break;
      case "Spocket":
        this.dataSourceRIGHT.dataset[3].data[index] = { "tooltext": !c.IsProjected && c.WornPercentage != null ? `<b>${c.WornPercentage}%</b> at ${c.SMU} SMU` : "", "smuProjected": c.SMUProjected, "isProjected": c.IsProjected, "value": c.WornPercentage, "index": index, "smu": c.SMU };
        break;
      default:
        break;
    }
  }

  buildProjectedByNearestSMURight(smuDatasetIndex: number, targetIndex: number, emptyValue: any = null) {
    const datasets = this.dataSourceRIGHT?.dataset;
    if (!datasets) return;
    const smuData = datasets[smuDatasetIndex]?.data || [];
    // Ensure target dataset exists
    if (!datasets[targetIndex]) {
      datasets[targetIndex] = { data: [] };
    }
    // Initialize target with empty values
    const targetData = smuData.map(() => ({ value: emptyValue }));

    // STEP 1: Find last actual (isProjected === false)
    let lastActualIndex = -1;
    smuData.forEach((item: any, index: number) => {
      if (item?.isProjected === false && item?.value != null) {
        lastActualIndex = index;
      }
    });

    // ONLY scan selected dataset
    const selectedDataset = datasets[smuDatasetIndex];

    selectedDataset?.data?.forEach((item: any) => {
      if (item?.smuProjected && item.smuProjected > 0) {
        item.tooltext =
          item.isProjected && item.value != null
            ? `<b>${item.value == 100 ? 100 : 120}%</b> at ${item.smu} SMU`
            : '';
        let nearestIndex = -1;
        let minDiff = Number.MAX_VALUE;
        // Find nearest SMU
        smuData.forEach((smuItem: any, index: number) => {
          if (smuItem?.smu != null) {
            const diff = Math.abs(smuItem.smu - item.smuProjected);
            if (diff < minDiff) {
              minDiff = diff;
              nearestIndex = index;
            }
          }
        });
        // STEP 3: Add connector point
        if (lastActualIndex !== -1) {
          targetData[lastActualIndex] = {
            ...smuData[lastActualIndex],
            index: lastActualIndex
          };
        }

        // STEP 4: Place projected at nearest index
        if (nearestIndex !== -1) {
          targetData[nearestIndex] = {
            ...item,
            smu: item.smuProjected,
            index: nearestIndex
          };
        }
      }
    });
    // Cleanup tooltext
    targetData.forEach((item: any) => {
      if (item?.tooltext && item.value !== 100 && item.value !== 120) {
        item.tooltext = '';
      }
    });
    const lastIndex = targetData.length - 1;
    datasets[targetIndex].data = targetData;
  }


  LoadTemperatureInspectionsForEquipment() {
    this._temperatureService.LoadTemperatureInspection(this.equipmentId, 0).subscribe(res => {
      this.TemperatureInspectionList = res;
      console.log("result", this.TemperatureInspectionList)
      if (this.TemperatureInspectionList.length > 0) {
        this.hasTemperatureInspection = true;
      }
      if (this.inspections != null) {
        this.inspections.map(x => {
          if (!x.IsThermography) {
            this.TemperatureInspectionList.map(y => {
              let idate = new Date(x.Date)
              let tdate = new Date(y.InspectionSummary.InspectionDate)
              if (idate.getTime() == tdate.getTime()) {
                x.hasTemperature = true;
              }
            })
          }
        })
      }
    })
  }

  getTitle(comp: ComponentDetails) {
    var OEM = comp.OEMPartNo;
    var MFR = comp.MFRPartNo;
    var value = "";
    if (OEM != null && MFR != null) {
      return value = "OEM Part# :" + OEM + '\n' + "Mfr.Part# :" + MFR;
    } else if (OEM != null) {
      return value = "OEM Part# :" + OEM;
    } else if (MFR != null) {
      return value = "Mfr.Part# :" + MFR;
    } else {
      return value;
    }
  }

  getPDFUoM() {
    this._equipmentService.GetUoM().subscribe(res => {
      if (res != null) {
        this.pdfUoM = (res === 'inch') ? 'inch' : 'mm';
      }
    });
  }

  getRopeShovelReportSyle() {
    this._equipmentService.GetRopeShovelReportStyle(this.equipmentId).subscribe(res => {
      if (res != null) {
        this.ropeStyleId = res;
      }
    })
  }

  openChangeJobsite() {
    const dialogRef = this._dialog.open(ChangeJobsiteComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        equipmentId: this.equipmentId,
        customerId: this.equipmentDetails.CustomerId
      }
    });
    dialogRef.afterClosed().subscribe(newJobsiteName => {
      if (newJobsiteName == null || newJobsiteName === undefined)
        return;
      if (newJobsiteName !== this.equipmentDetails.JobsiteName) {
        this.loadEquipmentDetails();
      }
    });
  }

  openUpdateMeter() {
    const updateMeterDialog = this._dialog.open(UpdateMeterComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        equipmentId: this.equipmentId,
        customerId: this.equipmentDetails.CustomerId,
        smuPrechange: this.equipmentDetails.Smu,
        doeCurrent: this.equipmentDetails.Doe,
        lastUpdateTime: this.equipmentDetails.LastInspectionDate == "Never" ? this.equipmentDetails.EquipmentSetupDate : this.equipmentDetails.LastInspectionDate, // todo
        bcmPrechange: this.equipmentDetails.Bcm,
        tonPrechange: this.equipmentDetails.Ton,
        IsRopeshovel: this.isFamilyRS,
        DistanceEnabled: this.equipmentDetails.EnableDistTravelledTracking
      }
    });

    const instance = updateMeterDialog.componentInstance;
    instance.changeLateUpdateTime(this.equipmentDetails.LastInspectionDate);

    updateMeterDialog.afterClosed().subscribe(newMeterReading => {
      if (newMeterReading === undefined)
        return;

      if (newMeterReading) {
        this.loadEquipmentDetails();
      }
    });
  }

  openChangeMeterUnit() {
    const changeMeterUnitDialog = this._dialog.open(ChangeMeterUnitComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        equipmentId: this.equipmentId,
        customerId: this.equipmentDetails.CustomerId,
        smuPrechange: this.equipmentDetails.Smu,
        PMUPrechange: this.equipmentDetails.propelHrs,
      }
    });

    changeMeterUnitDialog.afterClosed().subscribe(changeReadingUnit => {
      if (changeReadingUnit === undefined)
        return;

      if (changeReadingUnit) {
        this.loadEquipmentDetails();
      }
    });
  }
  openEditNextInspectionDate() {
    const UpdateInspectionForecasting = this._dialog.open(UpdateInspectionForecastingComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        equipmentId: this.equipmentId,
        inspectEvery: this.equipmentDetails.InspectEvery,
        inspectEveryUnitType: this.equipmentDetails.InspectEveryUnitTypeId
      }
    });

    UpdateInspectionForecasting.afterClosed().subscribe(forecast => {
      if (forecast === undefined)
        return;

      if (forecast) {
        this.loadEquipmentDetails();
      }
    });
  }


  InspectionId: number = 0;
  openInspectionPlannerDialog() {
    if (this.inspections.length > 0) {
      this.InspectionId = this.inspections[0].Id;
    }
    const inspectionPlannerDialog = this._dialog.open(InspectionPlannerComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        equipmentId: this.equipmentId,
        isInspector: this.isInspector,
        inspectionId: this.InspectionId
      },
      minWidth: 300
    });

    inspectionPlannerDialog.afterClosed().subscribe(result => {
      if (result) {
        this.loadEquipmentDetails();
      }
    });
  }

  //Thermography Inspection pop-up 
  CreateNewThermographyInspection() {
    const newTemperatureInspectionDialog = this._dialog.open(CreateDialogThermographyComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        equipmentId: this.equipmentId,
        eqSetupDate: this.equipmentDetails.EquipmentSetupDate,
        model: this.equipmentDetails.Model
      },
      minWidth: 500,
      disableClose: true,

    });

    newTemperatureInspectionDialog.afterClosed().subscribe(() => {
    });
  }

  GenerateTelerikPDF() {
    window.open(this._appService.getBaseURL() + 'api/ManageEquipment/GetManualInspectionReportPdf?equipmentId=' + this.equipmentId, '_blank');
  }

  //Download Manual Inspection Report
  DownloadManualInspectionReport() {
    this._equipmentService.GetManualInspection(this.equipmentId).subscribe(res => {
      if (res) {
        console.log("Report Url", this.telerikPdfReportUrl)
        window.open(this.telerikPdfReportUrl, '_blank');
      }
    }, error => {
      console.error(error);
      this._notification.error('Error', 'Please release this quote report first ');
    });
  }

  get telerikPdfReportUrl(): string {
    return this.reportUri + 'Report.aspx?equipmentId=' + this.equipmentId;
  }

  //Temperature Inspection pop-up 

  CreateNewTemperatureInspection() {
    const newTemperatureInspectionDialog = this._dialog.open(CreateNewTemperatureInspectionComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        equipmentId: this.equipmentId,
        eqSetupDate: this.equipmentDetails.EquipmentSetupDate,
        model: this.equipmentDetails.Model
      },
      minWidth: 500,
      disableClose: true,

    });

    newTemperatureInspectionDialog.afterClosed().subscribe(() => {
    });
  }

  //TT-7253 
  showInspection: boolean = false;
  CheckHasAccessToNewInspection() {
    this._userService.CheckAddNewIspectionMenuAccess().subscribe(res => {
      if (res == true)
        this.isInspector = true;
      else
        this.isInspector = false;
    })
  }

  CheckFindIspectionMenuAccess() {
    this._userService.CheckFindIspectionMenuAccess().subscribe(res => {
      if (res == true)
        this.showNotreleasdInspections = true;
      else
        this.showNotreleasdInspections = false;
    })
  }
  isAdministrator: boolean = false;
  adminEditRight: boolean = false;

  loadUserJobRoles() {
    this._loading.startLoading();
    this._userService.getUserJobRoles().subscribe(roles => {
      roles.forEach(r => {
        switch (r.Name) {
          case 'Inspectors':
            this.isInspector = true;
            break;
          case 'Undercarriage ONLY':
          case 'Undercarriage Inspector ONLY':
            this.isInspector = true;
            this.adminEditRight = true;
            this.isInterpreter = true;
            break;
          case 'Interpreters':
            this.isInterpreter = true;
            break;
          case 'Super User':
            this.isInspector = true;
            this.addCompRight = true;
          case 'Administrator':
            this.isInspector = true;
            this.isInterpreter = true;
            this.isAdministrator = true;
            this.adminEditRight = true;
            break;
          case 'Customer Admin':
            this.isInspector = true;
            this.isInterpreter = true;
            this.isAdministrator = true;
            this.adminEditRight = true;
            break;
        }
      });
      this._loading.finishedLoading();
    });
  }


  loadEquipmentAllTypesInspections() {
    this._loading.startLoading();
    this._equipmentService.getEquipmentAlltypeInspections(this.equipmentId).subscribe(inspections => {
      this.inspections = inspections;
      console.log("All Types", this.inspections)
      if (this.inspections.length > 1) {
        this.shouldDisableSetup = true;
      }
      if (this.showNotreleasdInspections == false) {
        this.inspections = this.inspections.filter(x => x.Interpreted == true);
      }
      this._loading.finishedLoading();
      this.inspectionsLoaded = true;

    });
  }
  loadEquipmentInspections() {
    this._loading.startLoading();
    this._equipmentService.getEquipmentInspections(this.equipmentId).subscribe(inspections => {
      this.inspections = inspections;
      console.log("this.inspections : General: ", this.inspections)
      if (this.inspections.length > 1) {
        this.shouldDisableSetup = true;
      }

      if (this.showNotreleasdInspections == false) {
        this.inspections = this.inspections.filter(x => x.Interpreted == true);
      }
      this._loading.finishedLoading();
      this.inspectionsLoaded = true;

    });
  }
  hasComponents: boolean = true;
  showCurrentWornOrForecast: boolean = false;

  receiveData(data: boolean) {
    this.showCurrentWornOrForecast = data;
  }

  getAbs(absoluteToBe): number {
    return Math.abs(absoluteToBe);
  }

  isCondition: boolean = true;
  loadEquipmentDetails() {
    this._loading.startLoading();
    this._equipmentService.getEquipmentDetails(this.equipmentId).subscribe(equipment => {
      this.nextInspectionDate = equipment.NextInspectionDate;
      this.IsAllowToggleCRoller = equipment.AllowToggleCRoller;
      this.equipmentDetails = equipment;
      this.isloaded = true;
      this.EnableDistTravelledTracking = equipment.EnableDistTravelledTracking;
      this.GetGridColumnsWithUserPreference();
      this.ShowPropelHrsPerc = equipment.ShowPropelHrsPerc;
      this.eqName = this.equipmentDetails.SerialNumber;
      this.ShowCRoller = this.equipmentDetails.ShowHideCRoller
      this.enableBogieShim = this.equipmentDetails.EnableBogieShim;
      this.enableManualInspection = this.equipmentDetails.EnableManualInspection;
      this.enableEqualiserBar = this.equipmentDetails.EnableEqualiserBar;
      this.isEqualiserBarExists = this.equipmentDetails.IsEqualiserBarExists;
      this.isCondition = this.equipmentDetails.IsCondition;
      this._app.setPageTitle('Manage Equipment | ' + equipment.SerialNumber + ' : ' + equipment.JobsiteName);
      this._loading.finishedLoading();
      this._app.getApplicationConfigValue("ThermographyEnabled").subscribe(result => {
        this.ThermographyEnabled = result
        if (this.ThermographyEnabled == "1") {
          if (this.equipmentDetails.IsThermographyEnable == true) {
            this.ThermEnabled = true;
            this.loadEquipmentAllTypesInspections();
            this.LoadTemperatureInspectionsForEquipment();
          } else
            this.ThermEnabled = false;
        } else {
          this.ThermEnabled = false;
        }
      });
      if (this.equipmentDetails.Family === 'Hydraulic Shovel/Excavator') {
        this.CheckHydrolicIsInspectMeasurementPoint();
      }

      if (this.equipmentDetails.FamilyId === +EquipmentFamily.ERS || this.equipmentDetails.FamilyId === +EquipmentFamily.RSH || this.equipmentDetails.FamilyId === +EquipmentFamily.MEX)
        this.isFromShovelDashBoard =true;
      else
        this.isFromShovelDashBoard =true;
      
    });
  }

  getBushTurnbackgroudColour(comp: ComponentDetails) {
    if (comp.CompartTypeId == 231 && comp.IsBushTurned == false) {

      let bushbudgetless10percent = comp.BushTurnedPercent - 10;
      let bushbudgetless10percentLife = (comp.BushTurnedBudgetLife / comp.BushTurnedPercent) * bushbudgetless10percent;
      //check for red colour
      if ((comp.PercentWorn >= comp.BushTurnedPercent) || (comp.Cmu >= comp.BushTurnedBudgetLife)) {
        return 'bushClass-X';
      }
      else if ((comp.PercentWorn >= bushbudgetless10percent && comp.PercentWorn < comp.BushTurnedPercent) || (comp.Cmu >= bushbudgetless10percentLife && comp.Cmu < comp.BushTurnedBudgetLife)) {
        return 'bushClass-C';
      }
      else {
        return 'bushClass-A';
      }
    } else if (comp.CompartTypeId == 231 && comp.IsBushTurned == true) {
      return 'bushClass-U';
    }
  }
  GetEQDetails() {
    this._setupService.getEquipmentSetupDetails(this.equipmentId).subscribe(result => {
      console.log('getEquipmentSetupDetails result', result);
      this.equipment_ = result;
    });
  }
  updateInspectionPlanner() {

    let model = new EquipmentInspectionForcastingViewModel();
    model.Id = this.equipmentId;
    model.JobsiteId = this.equipment_.JobsiteId;
    model.CreatedByUserId = this.equipment_.CreatedByUserId;
    model.EnableAutoInspectionPlanner = this.equipment_.EnableAutoInspectionPlanner;
    model.UsedMonday = this.equipment_.UsedMonday;
    model.UsedTuesday = this.equipment_.UsedTuesday;
    model.UsedWednesday = this.equipment_.UsedWednesday;
    model.UsedThursday = this.equipment_.UsedThursday;
    model.UsedFriday = this.equipment_.UsedFriday;
    model.UsedSaturday = this.equipment_.UsedSaturday;
    model.UsedSunday = this.equipment_.UsedSunday;
    model.InspectEvery = this.equipment_.InspectEvery;
    model.InspectEveryUnitTypeId = this.equipment_.InspectEveryUnitTypeId;
    model.HoursOfUsePerDay = this.equipment_.HoursOfUsePerDay;

    this._setupService.updateInspectionForecast(model).subscribe(result => {
      if (result.m_Item1 > 0) {
        this.loadEquipmentDetails();
      }
    });
  }
  getImage(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
  }

  updateUserLang(lang: string) {
    this.userLanguage = lang;
    this._ref.detectChanges();
  }

  IsHtdrolicShovelWorksLikeRSH: boolean = false;
  CheckHydrolicIsInspectMeasurementPoint() {
    this._app.getApplicationConfigValue("HydrolicMeasurementPointEnabled").subscribe(result => {
      if (result == "1") {
        this.IsHtdrolicShovelWorksLikeRSH = true;
      } else {
        this.IsHtdrolicShovelWorksLikeRSH = false;

      }
    });
  }

  isRopeShovel(): boolean {
    if (this.equipmentDetails != null && this.equipmentDetails.Family === 'Rope Shovel') return true;
    else {
      return false;
    }
  }

  isReportSaved(): boolean {
    return false;
  }

  newAction() {
    console.log("cleck__")
    this._pref.GetReplaceExistingTabStatus().subscribe(res => {
      if (res == "True") {
        this._router.navigate(['equipment-record-action', this.equipmentId]);
      } else {
        const baseUrl = `${location.protocol}//${location.host}/`;
        const fullUrl = `${baseUrl}equipment-record-action/${this.equipmentId}`;
        window.open(fullUrl, '_blank');
        //        // window.open('http://localhost:82/equipment-record-action/' + this.equipmentId, '_blank');
        //        window.open(this.appUris.UCUri + 'equipment-record-action/' + this.equipmentId, '_blank');
        //// 'http://localhost:82/equipment/1022564'
      }
    });
    // this._router.navigate(['equipment-record-action', this.equipmentId]);
  }
  oldAction() {
    this._router.navigate(['record-actions', this.equipmentId]);
  }
  newInspection() {
    this._router.navigate(['add-new-inspection', this.equipmentId, 0]);
  }

  newInspectionRSH(title: string) {
    const createnewRSHDialog = this._dialog.open(CreateRopeshovelInspectionComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        title: title,
        equipmentId: this.equipmentId,
        smuPrechange: this.equipmentDetails.Smu,
        modelId: this.equipmentDetails.ModelId,
        lastUpdateTime: this.equipmentDetails.LastInspectionDate == "Never" ? this.equipmentDetails.EquipmentSetupDate : this.equipmentDetails.LastInspectionDate, // todo
      },
      minWidth: 500,
      disableClose: true,
    });

    createnewRSHDialog.afterClosed().subscribe(() => {

    });
  }
  openLink(target: string, inspectionId: number) {
    switch (target) {
      case 'details':
        window.open(this.appUris.oldUCUri + 'track/TrackDetails.aspx?inspec_auto=' + inspectionId, '_blank');
        break;
      //case 'pdf':
      //  // window.open(this.appUris.oldUCUri + 'Track/GetTrackTreadsPdfReport.aspx?quoteAuto=' + inspectionId, '_blank');
      //  //window.open(this.reportUri + 'Report.aspx?quoteAuto=' + inspectionId + '&ud=' + this.userId);
      //  window.open(this._appService.getBaseURL() + 'api/Interpretation/DownloadQuotePDF?Inspectionid=' + inspectionId.toString() + '&QuoteId=' + inspectionId.toString(), '_blank');
      //  break;
      case 'edit':
        // window.open(this.appUris.oldUCUri + 'track/UndercarriageInspection.aspx?inspect=' + inspectionId, "_blank");
        this._router.navigate(['add-new-inspection', this.equipmentId, inspectionId]);
        break;
      case 'interpret':
        this._router.navigate(['/interpretation', inspectionId]);
        // window.open(this.appUris.oldUCUri + 'track/TrackUndercarriageView.aspx?inspec_auto=' + inspectionId, "_blank");
        break;
      case 'rs-inspection':
        //window.open(this.appUris.UCUri + 'rs-inspection/' + inspectionId, '_blank');
        window.open(this._app.getBaseURL() + 'rs-inspection/' + inspectionId, '_blank');
        break;

      case 'download':
        //window.open(this.appUris.UCUri + 'Api/RopeShovelInspection/GetRSPdf?InspectionId=' + inspectionId, '_blank');
        window.open(this._app.getBaseURL() + 'Api/RopeShovelInspection/GetRSPdf?InspectionId=' + inspectionId, '_blank');

        break;
      //window.open(this.appUris.UCUri + '/api/msinspection/getpdf?inspectionId=' + inspectionId + '&uom=' + this.pdfUoM + '&styleId=' + this.ropeStyleId, '_blank');

      case 'therm-inspection':
        this._router.navigate(['thermography-inspection', this.equipmentId, inspectionId]);
        break;
      case 'therm-pdf':
        //window.open(this.appUris.UCUri + '/api/ThermographyInspection/GetThermogarphyInspectionPDF?inspectionId=' + inspectionId + '&equipmentId=' + this.equipmentId, '_blank');
        window.open(this._app.getBaseURL() + 'api/ThermographyInspection/GetThermogarphyInspectionPDF?inspectionId=' + inspectionId + '&equipmentId=' + this.equipmentId, '_blank');
        break;

    }
  }

  DownloadTelerikPdf(inspectionId: number, quoteId: number, menuTrigger: any) {
    if (this.downloadingPdf) return;
    this.downloadingPdf = true;
    this._quotes.downloadQuotePDF(inspectionId, quoteId)
      .subscribe({
        next: (response) => {
          const blob = response.body as Blob;
          const contentDisposition = response.headers.get('content-disposition');
          let fileName = 'Interpretation.pdf'; // fallback
          if (contentDisposition) {
            const matches = /filename="?([^"]+)"?/.exec(contentDisposition);
            if (matches && matches[1]) {
              fileName = matches[1];
            }
          }
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
          this.downloadingPdf = false;
          menuTrigger.closeMenu();
        },

        error: (err) => {
          console.error('PDF download failed:', err);
          // optionally show toast/snackbar here
          this.downloadingPdf = false;
        },

        complete: () => {
          this.downloadingPdf = false;
        }
      });
  }


  Translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }
  getPositionStringDoubleComponents(Pos: number, CompartTypeId: number): string {
    if (CompartTypeId === 233) // Idler
      if (Pos === 1) return 'Front'; else if (Pos === 2) return 'Rear';
    if (CompartTypeId === 234 && Pos === 1) // Carrier roller
      return 'Front';
    if (CompartTypeId >= 230 && CompartTypeId <= 232 || CompartTypeId === 236 || CompartTypeId === 237 || CompartTypeId === 240 || Pos === undefined) {// Link, Bushing, Shoe, Sprocket
      if (Pos === 1) return 'Front'; else if (Pos === 2) return 'Rear';

    }
    if (CompartTypeId == 446)
      return 'Rear'
    return Pos.toString();
  }
  sanitize(image: string) {

    return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;base64,${image}`);
  }
  //getFamilyDetails(value: string) {
  //  console.log('value', value);
  //  this._equipmentService.getFamilyList().subscribe(result => {
  //    if (result != null) {
  //      const familydetails = result;
  //      familydetails.map(x => {
  //        //console.log("familydetails x:",x);
  //        if (x.typedesc === value) {
  //          this.FamilyImage_Chain = x.ChainImage;
  //          this.FamilyImage_Frame = x.FrameImage;
  //          if (x.typeid === 'RSH')
  //            this.isFamilyRS = true;
  //        }
  //      });
  //    }
  //  });
  //}

  getDifferenceClass(diffence: number) {

    if (diffence > 0) {
      return ' evalColorA';
    } else if (diffence < 0) {
      return ' evalColorX';
    } else { return 'DisplayNone'; }
  }

  SetupUnderCarriage() {
    if (this.inspections.length < 2) {
      if (
        this.UCSetupType == 1 ||
        (this.equipmentDetails.Family != "Rope Shovel" &&
          this.equipmentDetails.Family != "Hydraulic Shovel/Excavator")
      ) {
        this._pref.GetReplaceExistingTabStatus().subscribe(res => {
          if (res === "True") {
            this._router.navigate(['/setup-undercarriage', 'on-equipment', this.equipmentId]);
          } else {
            window.open(
              this._app.getBaseURL() + 'setup-undercarriage/on-equipment/' + this.equipmentId,
              '_blank'
            );
          }
        });
      } else {
        alert(
          "To Add or Update Undercarriage Components for Rope Shovels and Hydraulic Shovels, please update your user Preferences to Advanced."
        );
      }
    }
  }

  SetupEquipment() {
    if (this.inspections.length < 2)
      this._pref.GetReplaceExistingTabStatus().subscribe(res => {
        if (res == "True") {
          this._router.navigate(['/setup-equipment', this.equipmentId]);
        } else {
          window.open(this._app.getBaseURL() + 'setup-equipment/' + this.equipmentId, '_blank');
        }
      });
  }

  getDisable() {
    if (this.inspections.length > 1) {
      return 'DisabledClass';
    } else {
      return '';
    }
  }

  getEquipmentSetupTooltip() {
    if (this.inspections.length > 1) {
      var value = 'This equipment has 2 or more inspections';
      return this.Translate(value);

    } else {
      return "";
    }
  }

  EdiEqImage(img: string) {
    let viewPhotoModalRef = this._dialog.open(ViewPhotoComponent, {
      data: {
        photoType: 'equipment_Img',
        equipment_id: this.equipmentId,
        img: img
      }
    });
    viewPhotoModalRef.afterClosed().subscribe(reloadPhoto => {
      if (reloadPhoto)
        this.loadEquipmentDetails();
    });
  }

  UpdateEqStaus(EqStaus: number, value: string) {
    this._equipmentService.UpdateEquipmentStatus(this.equipmentId, EqStaus).subscribe(res => {
      if (res == true) {
        this.equipmentDetails.EqStatus = value;
        this._notification.success("Sucessfully update the Equipment Status");
      } else {
        this._notification.error("Failed to update the Equipment Status");
      }
    })
  }

  updateEqConditionStaus(EqStaus: number, value: string) {
    this._equipmentService.UpdateEquipmentConditionStatus(this.equipmentId, EqStaus).subscribe(res => {
      if (res == true) {
        //this.equipmentDetails.EqConditionStatus = value;
        this._notification.success("Sucessfully update the Equipment Condition Status");
      } else {
        this._notification.error("Failed to update the Equipment Condition Status");
      }
    });
  }

  UpdateShowhideCRoller(Status: boolean) {
    this._equipmentService.UpdateEquipmentShowHideCR(this.equipmentId, Status).subscribe(res => {
      if (res == true) {
        this.reloadEquipmentOverview = false;
        setTimeout(() => {
          this.reloadEquipmentOverview = true;
        });
      } else {
        this._notification.error("Failed to update the Equipment Status");
      }
    })
  }


  //Only If job role is Administartor acesss 
  HideInspection(inspectionId: number) {

    this._equipmentService.HideInspection(inspectionId).subscribe(res => {
      if (res == true) {
        this._notification.success("Inspection hidden successfully")
        this.loadEquipmentInspections();
      } else {
        this._notification.error("Please contact Tracktreads Support")
      }
    })
  }

  OpenDeleteInspection(inspectionId) {
    const addSectionDialog = this._dialog.open(DeleteConfirmDigilatFormDialogComponent, {
      data: {
        Value: true
      },

      disableClose: true
    });
    addSectionDialog.afterClosed().subscribe(res => {
      if (res == true) {
        this.HideInspection(inspectionId);
      }
    });
  }

  getReportUrl() {
    this._appService.getApplicationConfigValue("ReportDirectory").subscribe(result => {
      this.reportUri = result.replace("/GSNetImages", "");

      console.log("this.reportUri", this.reportUri);
    });
  }


  //open Document Library
  openAttachedDocs(SMU, Date, InspectionId) {
    const dialogRef = this._dialog.open(InspectionAttachedDocsComponent, {
      width: '50%',
      disableClose: true,

      data: {
        InspectionDate: Date,
        SMU: SMU,
        InspectionId: InspectionId,
        IsUC: true,
      }
    });

    dialogRef.afterClosed().subscribe(() => {
      this.loadEquipmentInspections();
    });
  }

  addComment(equipment: any) {

    const viewCommentModalRef = this._dialog.open(ConditionCommentModalComponent, {
      width: '1032px',
      data: {
        comingFrom: CommentPopupRequestPageAndFunc.EquipmentDetailComment,
        equipmentId: this.equipmentId,
        comment: equipment.EquipmentComments
      }
    });
    viewCommentModalRef.afterClosed().subscribe(reloadComment => {
      if (reloadComment) {
        this.equipmentDetails.EquipmentComments = reloadComment;
      }
    });
  }
  handleHasComponent(value: boolean) {
    this.hasComponents = value;
    this.checkAvailableMenuItems();
  }

  handleHasComponentCR(value: boolean) {
    this.hasCRoller = value;
    console.log(this.hasCRoller);
    //this.loadEquipmentDetails();
  }

  hasAvailableMenuItems = false;
  checkAvailableMenuItems(): void {
    // Implement your logic to check if any of the buttons are available
    // For example, based on isInspector, isRopeShovel(), TempEnabled, ThermEnabled, etc.
    if (
      this.isInspector &&
      (!this.isRopeShovel() || this.hasComponents || !this.IsHtdrolicShovelWorksLikeRSH) ||
      this.isRopeShovel() ||
      (this.isInspector && this.IsHtdrolicShovelWorksLikeRSH) ||
      (this.isInspector && this.TempEnabled && this.hasComponents) ||
      (this.isInspector && this.ThermEnabled)
    ) {
      this.hasAvailableMenuItems = true;
    } else {
      this.hasAvailableMenuItems = false;
    }
  }

  getFamilyRenameSprocketFlag() {
    this._equipmentService.getFamilyRenameSprocketFlag(this.equipmentId).subscribe(res => {
      this.renameSprocket = res;
      this.dataSourceLEFT = {
        chart: {
          yaxisname: this.Translate("Worn Percentage"),
          numdivlines: "10",
          legenditemfontsize: "15",
          legenditemfontbold: "1",
          theme: "fusion",
          yAxisMaxValue: "120",
          numberSuffix: "%",
          showValues: "0",
          xaxisname: this.Translate("Component Hours"),
          creditLabel: false,
          legendNumColumns: "4",
          //  plottooltext: "<b>$dataValue%</b> at $label SMU",
          drawanchors: "1",
          linethickness: "2",
          connectnulldata: "1",
          plottooltext: "",
          // Important
          sharedtooltip: "0",
          showtooltip: "0",
          //plottooltext: "",
          showhovereffect: "0"
        },
        categories: [
          {
            category: [
              {
                label: "0"
              },
            ]
          }
        ],
        dataset: [
          {
            seriesname: "Link",
            color: "#4ABFFE",

            //plottooltext: "<b>$dataValue%</b> worn $seriesName on $label",
            data: [
              {
                value: "0"
              }
            ]
          },
          {
            seriesname: "Bush",

            color: "#EEC210",
            //  plottooltext: "<b>$dataValue%</b> worn $seriesName on $label",
            data: [
              {
                value: "0",
              }
            ]
          },
          {
            seriesname: "Shoe",

            color: "#FF5733",
            // plottooltext: "<b>$dataValue%</b> worn $seriesName on $label",
            data: [
              {
                value: "0",
              }
            ]
          },
          {
            seriesname: (this.renameSprocket ? "Segments" : "Spocket"),
            color: "#C84AFE",

            //plottooltext: "<b>$dataValue%</b> worn $seriesName on $label",
            data: [
              {
                value: "0",
              }

            ]
          },
          {
            seriesname: "Link Projection",
            color: "#4ABFFE",
            tooltext: "",
            showtooltip: "0",
            // plottooltext: "<b>$dataValue%</b> worn $seriesName on $label",
            dashed: 1,
            data: [
              {
                value: "0",
              }

            ]
          },
          {
            seriesname: "Bush Projection",
            tooltext: "",
            showtooltip: "0",
            color: "#EEC210",
            //  plottooltext: "<b>$dataValue%</b> worn $seriesName on $label",
            dashed: 1,
            data: [
              {
                value: "0",
              }

            ]
          },
          {
            seriesname: "Shoe Projection",
            color: "#FF5733",
            showToolTip: "0",
            tooltext: "",
            showtooltip: "0",
            // plottooltext: "<b>$dataValue%</b> worn $seriesName on $label",
            dashed: 1,
            data: [
              {
                value: "0",
              }

            ]
          },
          {
            seriesname: (this.renameSprocket ? "Segments" : "Spocket") + " Projection",
            color: "#C84AFE",
            tooltext: "",
            showtooltip: "0",
            // plottooltext: "<b>$dataValue%</b> worn $seriesName on $label",
            dashed: 1,
            data: [
              {
                value: "0",
              }

            ]
          }

        ]
      };

      this.dataSourceRIGHT = {
        chart: {
          //caption: "Right Side - Component Wear Graph and Forecast", 
          yaxisname: this.Translate("Worn Percentage"),
          numdivlines: "10",
          legenditemfontsize: "15",
          legenditemfontbold: "1",
          theme: "fusion",
          yAxisMaxValue: "120",
          numberSuffix: "%",
          showValues: "0",
          xaxisname: this.Translate("Component Hours"),
          creditLabel: false,
          legendNumColumns: "4",
          //  plottooltext: "<b>$dataValue%</b> at $label SMU",
          drawanchors: "1",
          linethickness: "2",
          connectnulldata: "1",
          plottooltext: "",
          // Important to hide tool tip
          sharedtooltip: "0",
          showtooltip: "0",
          showhovereffect: "0"
        },
        categories: [
          {
            category: [
              {
                label: "0"
              },
            ]
          }
        ],
        dataset: [
          {
            seriesname: "Link",
            color: "#4ABFFE",
            data: [
              {
                value: "0"
              }
            ]
          },
          {
            seriesname: "Bush",
            color: "#EEC210",
            data: [
              {
                value: "0",
              }
            ]
          },
          {
            seriesname: "Shoe",
            color: "#FF5733",
            data: [
              {
                value: "0",
              }
            ]
          },
          {
            seriesname: (this.renameSprocket ? "Segments" : "Spocket"),
            color: "#C84AFE",
            data: [
              {
                value: "0",
              }

            ]
          },
          {
            seriesname: "Link Projection",
            color: "#4ABFFE",
            dashed: 1,
            data: [
              {
                value: "0",
              }

            ]
          },
          {
            seriesname: "Bush Projection",
            color: "#EEC210",
            dashed: 1,
            data: [
              {
                value: "0",
              }

            ]
          },
          {
            seriesname: "Shoe Projection",
            color: "#FF5733",
            dashed: 1,
            data: [
              {
                value: "0",
              }

            ]
          },
          {
            seriesname: (this.renameSprocket ? "Segments" : "Spocket") + " Projection",
            color: "#C84AFE",
            dashed: 1,
            data: [
              {
                value: "0",
              }

            ]
          }
        ]
      };
    });
  }


  handlePlotClickR(eventObj: any, dataObj: any, side: number) {
    // Use NgZone to ensure Angular detects the change immediately
    this.zone.run(() => {
      this.selectedSeries = dataObj.datasetName;
      if (dataObj.datasetName.includes("Projection")) {
        const result = dataObj.datasetName.split("Projection")[0].trim();

        var data = this.CompInspectionInfo_R.find(x => x.CompartName == result && x.WornPercentage == dataObj.dataValue);
        const dateValue = new Date(data.Date);
        const minDate = new Date("0001-01-01T00:00:00");
        if (dateValue.getTime() !== minDate.getTime()) {
          this.selectedData = `| InspectionDate: ${this.datePipe.transform(data?.Date, 'MM/dd/yyyy')} | SMU: ${data?.SMU} | Wear: ${dataObj.displayValue}`;
        } else
          this.selectedData = `|  SMU: ${data?.SMUProjected} | Wear: ${dataObj.displayValue}`;
      } else {
        var data = this.CompInspectionInfo_R.find(x => x.CompartName == dataObj.datasetName && x.WornPercentage == dataObj.dataValue);
        this.selectedData = `| InspectionDate: ${this.datePipe.transform(data?.Date, 'MM/dd/yyyy')} | SMU: ${data?.SMU} | Wear: ${dataObj.displayValue}`;
      }

      if (side == 1) {
        this.enableLeft = true;
        this.enableRight = false;
      } else {
        this.enableLeft = false;
        this.enableRight = true;
      }
    });
  }

  handlePlotClickL(eventObj: any, dataObj: any, side: number) {
    // Use NgZone to ensure Angular detects the change immediately
    this.zone.run(() => {
      this.selectedSeries = dataObj.datasetName;
      if (dataObj.datasetName.includes("Projection")) {
        const result = dataObj.datasetName.split("Projection")[0].trim();

        var data = this.CompInspectionInfo.find(x => x.CompartName == result && x.WornPercentage == dataObj.dataValue);
        const dateValue = new Date(data.Date);
        const minDate = new Date("0001-01-01T00:00:00");
        if (dateValue.getTime() !== minDate.getTime()) {
          this.selectedData = `| InspectionDate: ${this.datePipe.transform(data?.Date, 'MM/dd/yyyy')} | SMU: ${data?.SMU} | Wear: ${dataObj.displayValue}`;
        } else {
          this.selectedData = `|  SMU: ${data?.SMUProjected} | Wear: ${dataObj.displayValue}`;
        }
      } else {
        var data = this.CompInspectionInfo.find(x => x.CompartName == dataObj.datasetName && x.WornPercentage == dataObj.dataValue);
        this.selectedData = `| InspectionDate: ${this.datePipe.transform(data?.Date, 'MM/dd/yyyy')} | SMU: ${data?.SMU} | Wear: ${dataObj.displayValue}`;
      }

      if (side == 1) {
        this.enableLeft = true;
        this.enableRight = false;
      } else {
        this.enableLeft = false;
        this.enableRight = true;
      }
    });
  }

  ////  <!-- TT-9602 -->
  openColumnSettingsDialog() {
    const dialogRef = this._dialog.open(AddNewComponentComponent, {
      width: '700px',
      data: {
        EquipmentId: this.equipmentId,
        IsReplaceExistingTab: this.showEnableReplaceExistingTab,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        //this.loadEquipmentSystems();
      }
    });
  }

  openEqualiserBarDialog() {
    const dialogRef = this._dialog.open(AddNewComponentComponent, {
      width: '700px',
      data: {
        EquipmentId: this.equipmentId,
        IsReplaceExistingTab: this.showEnableReplaceExistingTab,
        BrandId: this.equipmentDetails.MakeId,
        BudgetLife: this.equipmentDetails.EqBudgetLife,
        AddToAllInsp: this.inspections.length == 0 ? false : true,
        isEqualiserBar: true,
        jobsiteId: this.equipmentDetails.JobsiteId,
        famId: this.equipmentDetails.FamilyId,
        modelId: this.equipmentDetails.ModelId,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadEquipmentDetails();
      }
    });
  }

  EditSerial(sys: SystemDetails) {
    const editSeralNumber = this._dialog.open(EditSystemSerialNumberComponent, {
      data: {
        SerialNumber: sys.SerialNumber,
        systemId: sys.Id,
      }
    });
    editSeralNumber.afterClosed().subscribe(details => {
      if (details == true) {
        this._interp.GetSystemSerial(sys.Id).subscribe(res => {
          sys.SerialNumber = res;
        })
      }
    });
  }

  UpdateBudgetLife(Id: number, BudgetLife: number) {
    this._interp.UpdateBudgetLife(Id, BudgetLife, ScreenCode.ME).subscribe(res => {
      if (res) {
        this._notification.success("Budget Life updated successfully")
      } else {
        this._notification.error("Error while updating Budget Life, Please contact Tracktreads Support")
      }
    })
  }

  UpdateFrame(Id: number, FCost: number) {
    this._interp.UpdateFrameCost(Id, FCost, ScreenCode.ME).subscribe(res => {
      if (res) {
        this._notification.success("Frame cost updated successfully")
      } else {
        this._notification.error("Error while updating Frame cost, Please contact Tracktreads Support")
      }
    })
  }

  UpdateBudgetDistance(Id: number, BudgetDistance: number) {
    this._interp.UpdateBudgetDistance(Id, BudgetDistance, ScreenCode.ME).subscribe(res => {
      if (res) {
        this._notification.success("Budget Distance updated successfully")
      } else {
        this._notification.error("Error while updating Budget Distance, Please contact Tracktreads Support")
      }
    })
  }

  // updateSystemCondition(system: SystemDetails, newValue: string) {
  //   if (!this.isInspector)
  //     return;
  //   this._interp.updateSystemCondition(system.Id, newValue).subscribe(r => {
  //     if (r.m_Item1) {
  //       system.SystemCondition = newValue;
  //       system.SystemConditionColor = r.m_Item2;
  //       this._notification.success("Frame Condition updated successfully")
  //     } else {
  //       this._notification.error("Error while updating Frame Condition, Please contact Tracktreads Support")
  //     }
  //   })
  // }

  isAllowEditByUserId() {
    this._userService.isAllowEditByUserId().subscribe(res => {
      this.isAdminAllowEdit = res;
    });
  }

  //TT-9235
  getUserUOD() {
    this._pref.getGeneralTabPreferences().subscribe(res => {
      this.userUOD = res.UnitofDistance;
    })
  }
  // to convert distance from kilometers to miles for display purpose
  convertDistanceKmToMi(distance: number): number {
    return this.userUOD === 'km' ? distance : Math.round(distance * 0.621371 * 10) / 10;
  }

  getEquipmentStatus() {
    this._equipmentService.getAllEquipmentStatus().subscribe(res => {
      this.allEquipmentStatus = res;
    });
  }

  GetEquipmentConditionStatuses() {
    this._equipmentService.GetEquipmentConditionStatuses(this.equipmentId).subscribe(res => {
      this.equipmentConditionStatuses = res;
    });
  }

  GetEvalColour(comp: ComponentDetails, worn: number) {
    if (this.EvalautionRange == null)
      return 'Eval-U';

    var compType = comp.CompartTypeId;
    // if (comp.Reading === -1 || comp.ToolId === toolType.YESorNO || comp.ToolId === toolType.PassorFail) {
    //   return 'Eval-U';
    // }

    switch (compType) {
      case 230: //Link
        if (this.EvalautionRange.LinkC != null && this.EvalautionRange.LinkC != undefined) {
          if (worn <= this.EvalautionRange.LinkA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.LinkB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.LinkC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.LinkA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.LinkB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 231://Bush
        if (this.EvalautionRange.BushC != null) {
          if (worn <= this.EvalautionRange.BushA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.BushB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.BushC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.BushA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.BushB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 232: //Shoe
        if (this.EvalautionRange.ShoeC != null) {
          if (worn <= this.EvalautionRange.ShoeA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.ShoeB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.ShoeC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.ShoeA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.ShoeB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 233://Idler
        if (this.EvalautionRange.LinkC != null && this.EvalautionRange.LinkC != undefined) {
          if (worn <= this.EvalautionRange.LinkA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.LinkB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.LinkC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.LinkA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.LinkB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 234://carrier Roller
        if (this.EvalautionRange.CarrierRollerC != null) {
          if (worn <= this.EvalautionRange.CarrierRollerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.CarrierRollerB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.CarrierRollerC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.CarrierRollerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.CarrierRollerB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 235://track Roller
        if (this.EvalautionRange.TrackRollerC != null) {
          if (worn <= this.EvalautionRange.TrackRollerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.TrackRollerB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.TrackRollerC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.TrackRollerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.TrackRollerB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }
      case 236://Sprokcket
        if (this.EvalautionRange.SprocketC != null) {
          if (worn <= this.EvalautionRange.SprocketA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.SprocketB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.SprocketC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.SprocketA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.SprocketB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 240://Elognation
        if (this.EvalautionRange.ElongationC != null) {
          if (worn <= this.EvalautionRange.ElongationA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.ElongationB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.ElongationC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.ElongationA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.ElongationB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 417://Crawler
        if (this.EvalautionRange.CrawlerGuideC != null) {
          if (worn <= this.EvalautionRange.CrawlerGuideA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.CrawlerGuideB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.CrawlerGuideC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.CrawlerGuideA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.CrawlerGuideB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 446://RSREAR
        if (this.EvalautionRange.RSRearIdlerC != null) {
          if (worn <= this.EvalautionRange.RSRearIdlerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.RSRearIdlerB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.RSRearIdlerC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.RSRearIdlerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.RSRearIdlerB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }
      case 237://Idler

        if (worn <= 30)
          return 'Eval-A';
        else if (worn <= 50)
          return 'Eval-B';
        else if (worn <= 70)
          return 'Eval-C';
        else
          return 'Eval-X';
      default:
        break;
    }
  }

  
  LoadEvalautionForEquipment() {
    this._evalService.GetSelectedLevelRangesForSelectedEquipment(this.equipmentId).subscribe(res => {
      this.EvalautionRange = res;
    })
  }
 
  GetGridColumnsWithUserPreference() {
    this._pref.GetGridColumnsWithUserPreferenceAsync(ScreenCode.ManageEquipment).subscribe(res => {
      this.DashboardPrefernceList = res;

      if (!this.EnableDistTravelledTracking) {
        this.DashboardPrefernceList = this.DashboardPrefernceList
          .filter(c => !c.ColumnDisplayName.includes('DOC'))
          ;
      }
      this.dashboardPreferneceView =
        this.DashboardPrefernceList
          .filter(c => c.IsSelected)
          .map(c => c.GridId);

      this.CheckTheValues();
    })
  }

  savePreferences() {
    const request = new UserGridPreferenceUpdateDto();
        request.ScreenCode = ScreenCode.ManageEquipment;
        request.GridIds = this.dashboardPreferneceView
    this._pref.UpdateGridColumnPreference(request).subscribe(res => {
      if (res) {
        this.GetGridColumnsWithUserPreference();
        this.notification.success('Saved', 'Preferences updated successfully.');
      }
    });
  }

  isColumnSelected(column: ManageEquipmentColumn, dashboardPreferenceView: number[]): boolean {
    return dashboardPreferenceView?.includes(column) ?? false;
  }

  CheckTheValues() {
    this.showCMU = this.isColumnSelected(ManageEquipmentColumn.CMU, this.dashboardPreferneceView);
    this.showResLife100 = this.isColumnSelected(ManageEquipmentColumn.ResLife100, this.dashboardPreferneceView);
    this.showResLife120 = this.isColumnSelected(ManageEquipmentColumn.ResLife120, this.dashboardPreferneceView);
    this.showDOC = this.isColumnSelected(ManageEquipmentColumn.DOC, this.dashboardPreferneceView);
    this.showResDOC100 = this.isColumnSelected(ManageEquipmentColumn.ResDOC100, this.dashboardPreferneceView);
    this.showResDOC120 = this.isColumnSelected(ManageEquipmentColumn.ResDOC120, this.dashboardPreferneceView);
    this.showReading = this.isColumnSelected(ManageEquipmentColumn.Reading, this.dashboardPreferneceView);
    this.showWorn0 = this.isColumnSelected(ManageEquipmentColumn.Worn0Percent, this.dashboardPreferneceView);
    this.showWorn100 = this.isColumnSelected(ManageEquipmentColumn.Worn100Percent, this.dashboardPreferneceView);
    this.showWorkOrder = this.isColumnSelected(ManageEquipmentColumn.WorkOrder, this.dashboardPreferneceView);
    this.showReplacementDate = this.isColumnSelected(ManageEquipmentColumn.ReplacementDate, this.dashboardPreferneceView);
    this.showBrand = this.isColumnSelected(ManageEquipmentColumn.Brand, this.dashboardPreferneceView);
    this.showBudgetLife = this.isColumnSelected(ManageEquipmentColumn.BudgetLife, this.dashboardPreferneceView);
    this.showBushTurned = this.isColumnSelected(ManageEquipmentColumn.BushTurned, this.dashboardPreferneceView);
    this.showProjectedLife100 = this.isColumnSelected(ManageEquipmentColumn.ProjectedLife100, this.dashboardPreferneceView);
    this.showProjectedLife120 = this.isColumnSelected(ManageEquipmentColumn.ProjectedLife120, this.dashboardPreferneceView);
    this.showDifference = this.isColumnSelected(ManageEquipmentColumn.Difference, this.dashboardPreferneceView);
    this.showPurchaseCost = this.isColumnSelected(ManageEquipmentColumn.PurchaseCost, this.dashboardPreferneceView);
    this.showRepairCost = this.isColumnSelected(ManageEquipmentColumn.RepairCost, this.dashboardPreferneceView);
    this.showActualWearRate = this.isColumnSelected(ManageEquipmentColumn.ActualWearRate, this.dashboardPreferneceView);
    this.showBudgetWearRate = this.isColumnSelected(ManageEquipmentColumn.BudgetWearRate, this.dashboardPreferneceView);
    this.showInstallDate = this.isColumnSelected(ManageEquipmentColumn.InstallDate, this.dashboardPreferneceView);
    this.showPropelBudget = this.isColumnSelected(ManageEquipmentColumn.PropelBudget, this.dashboardPreferneceView);
  }

  getEquipmentCompartTypes() {
    this._equipmentService.GetEquipmentCompartmentTypes(this.equipmentId).subscribe(res => {
      this.EquipmentCompartmentTypeModel = res;
    });
  }

  AvgComponentPopup() {
    const AvgComponent = this._dialog.open(AvgWornCalculationPopUpComponent, {
      width: '400px',
      data: {
        EquipmentId: this.equipmentId,
      }
    });
    AvgComponent.afterClosed().subscribe(details => {
      if (details == true) {
        this.loadEquipmentDetails();
      }
    });
  }

  openSummaryNotes() {
    const summaryNotes = this._dialog.open(EquipmentNotesHistoryComponent, {
      width: '1200px',
      maxWidth: '95vw',
      autoFocus: false,
      restoreFocus: false,
      disableClose: true,
      data: {
        EquipmentId: this.equipmentId,
        Title: "Equipment Summary Notes",
        HistoryTitle: "Summary Notes History",
        SummaryNotesExists: this.equipmentDetails.SummaryNotesExists,
        ScreenId: 14,
        eqConditionStatusId: this.equipmentDetails.EqConditionStatusId
      }
    });
    summaryNotes.afterClosed().subscribe(details => {
      if (details)
        this.equipmentDetails.SummaryNotesExists = details.summaryNotesExists;
      this.equipmentDetails.EqConditionStatusId = details.eqConditionStatusId;
    });
  }

  onTabChange(event: MatTabChangeEvent): void {
    this.tabularTabClicked = event.tab.textLabel === this.Translate('Tabular Inspection History');
    this.isOptionsVisible = !this.tabularTabClicked;
  }

}
